<template>
  <app-layout title="Information">
    <template #header>
      <h2 class="font-semibold text-xl text-gray-800 leading-tight">
        お知らせ詳細
      </h2>
    </template>
    <div class="px-4 py-4 flex flex-col items-center">
      <div class="mt-10 sm:mt-0 min-w-max">
        <form
          action="#"
          method="POST">
          <div class="shadow overflow-hidden sm:rounded-md">
            <div class="px-4 py-5 bg-white sm:p-6">
              <div class="grid grid-cols-6 gap-6">
                <!-- <div class="col-span-6">
                  <label
                    for="category"
                    class="block text-sm font-medium text-gray-700">
                    カテゴリ
                  </label>
                  <div class="col-span-8">
                    <input
                      id="category"
                      type="text"
                      v-model="form.category_id"
                      class="w-full rounded border-gray-400" />
                  </div>
                </div> -->

                <div class="col-span-6 sm:col-span-3">
                  <label
                    for="isPublished"
                    class="block text-sm font-medium text-gray-700">
                    カテゴリ
                  </label>
                  <select
                    v-model="form.category_id"
                    :class="{ 'bg-red-100': !!form.errors.category_id }"
                    class="mt-1 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm">
                    <option
                      v-for="(n, i) in informationCategories"
                      :key="i"
                      :value="i">
                      {{ n }}
                    </option>
                  </select>
                  <input-error
                    :message="form.errors.category_id"
                    class="mt-2" />
                </div>

                <div class="col-span-6">
                  <label
                    for="subject"
                    class="block text-sm font-medium text-gray-700">
                    件名
                  </label>
                  <div class="col-span-8">
                    <input
                      id="subject"
                      v-model="form.subject"
                      type="text"
                      :class="{ 'bg-red-100': !!form.errors.subject }"
                      class="w-full rounded border-gray-400" />
                    <input-error
                      :message="form.errors.subject"
                      class="mt-2" />
                  </div>
                </div>

                <div class="col-span-6">
                  <label
                    for="description"
                    class="block text-sm font-medium text-gray-700">
                    本文
                  </label>
                  <textarea
                    id="description"
                    v-model="form.description"
                    class="resize w-full rounded border-gray-400"
                    :class="{ 'bg-red-100': !!form.errors.description }"
                    cols="40"
                    rows="10">
                  </textarea>
                  <input-error
                    :message="form.errors.description"
                    class="mt-2" />
                </div>

                <div class="col-span-6 sm:col-span-3">
                  <label
                    for="isPublished"
                    class="block text-sm font-medium text-gray-700">
                    公開設定
                  </label>
                  <select
                    id="isPublished"
                    v-model="form.is_published"
                    name="isPublished"
                    class="mt-1 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm">
                    <option
                      key="0"
                      value="0">
                      非公開
                    </option>
                    <option
                      key="1"
                      value="1">
                      公開
                    </option>
                  </select>
                </div>
                <div class="col-span-6 sm:col-span-3">
                  <label
                    for="target"
                    class="block text-sm font-medium text-gray-700">
                    配信設定
                  </label>
                  <select
                    id="target"
                    v-model="form.target"
                    name="target"
                    class="mt-1 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm">
                    <option
                      key="0"
                      value="0">
                      全て
                    </option>
                    <option
                      key="1"
                      value="1">
                      模試
                    </option>
                    <option
                      key="2"
                      value="2">
                      アプリ
                    </option>
                  </select>
                </div>
              </div>
            </div>
            <div class="px-4 py-3 bg-gray-50 flex justify-between sm:px-6">
              <div>
                <button
                  type="button"
                  class="py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-gray-500 hover:bg-grey-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-grey-500"
                  @click="onClickedCancel">
                  キャンセル
                </button>
              </div>
              <div>
                <button
                  v-if="!form.wasSuccessful"
                  class="py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                  @click.prevent="onSubmitted">
                  保存
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </app-layout>
</template>

<script setup>
import moment from 'moment'
import { Inertia } from '@inertiajs/inertia'
import { usePage } from '@inertiajs/inertia-vue3'
import {
  reactive, onMounted, computed,
} from 'vue'
import InputError from '@/Jetstream/InputError'
import AppLayout from '@/Layouts/AppLayout'

const props = defineProps({
  information: {
    type: Object,
    default: () => ({ id: null }),
  },
})

const informationCategories = computed(() => usePage().props.value.informationCategories)

const edit = (information) => {
  Inertia.post(route('information.show'), {
    information,
  })
}

const form = reactive(Inertia.form({
  id: null,
  _method: 'POST',
  category_id: null,
  subject: null,
  description: null,
  is_published: 0,
  target: 0,
}))

onMounted(() => {
  if (props.information.id) {
    form._method = 'PUT' // eslint-disable-line no-underscore-dangle
    form.id = props.information.id
    form.category_id = props.information.category_id
    form.subject = props.information.subject
    form.description = props.information.description
    form.is_published = props.information.is_published
    form.target = props.information.target
  }
})

const onSubmitted = async () => {
  if (props.information.id) {
    await form.post(route('information.update', {
      information: props.information,
      category_id: form.category_id,
      subject: form.subject,
      description: form.description,
      is_published: form.is_published,
      target: form.target,
    }))
  } else {
    await form.post(route('information.store', {
      information: props.information,
      category_id: form.category_id,
      subject: form.subject,
      description: form.description,
      is_published: form.is_published,
      target: form.target,
    }))
  }
}

const onClickedCancel = () => {
  Inertia.get(route('information'))
}

</script>
